<footer class="gb_enteFooter">
  <div class="container">
    <div class="row">
      <div class="col d-flex flex-wrap flex-column flex-md-row justify-content-between">
        <div class="gb_footLeftside w-50">
          <div class="gb_pagoPALogofoot">
            <svg viewBox="0 0 72 48">
              <title>PagoPA</title>
              <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4z
 M54,2.4h-3.3v9.5H54V2.4z" />
              <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5
h2.8V8.5z" />
              <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2
c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
              <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1
h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
              <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7
c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
              <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2
c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3
V2.5h3.3V11.9z" />
            </svg>

            <span>
              <strong>{{"generic.labels.pagopa.title" | translate}}</strong>
              {{"generic.labels.pagopa.subtitle" | translate}}
            </span>
          </div>
          <div class="gb_tagpagoPA text-center text-lg-start">
            {{"generic.labels.pagopa.description" | translate}}
            <a href="https://www.pagopa.gov.it/" target="_blank" rel="noopener" title="pagoPA" tabindex="0"
              aria-label="pagoPA"> {{"generic.buttons.seeMore" | translate}}</a>
          </div>
        </div>
        <div class="gb_footRightside w-50">
          <span>{{"generic.labels.psp" | translate}}</span>
          <a href="https://www.pagopa.gov.it/it/prestatori-servizi-di-pagamento/elenco-PSP-attivi/" class="gb_btncta w"
            target="_blank" rel="noopener" tabindex="0" title="{{'generic.buttons.psp' | translate}}"
            attr.aria-label="{{'generic.buttons.psp' | translate}}">
            {{"generic.buttons.psp" | translate}}
            <svg viewBox="0 0 24 24">
              <path
                d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929L14.5858 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H14.5858L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z">
              </path>
            </svg>
          </a>
        </div>
        <div class="gb_footLeftside w-50">
          <ul class="gb_menufoot">
            <li>
              <a href="javascript:void(0);" [routerLink]="['/'+storeService.codIpa+'/personal/dashboard']"
                title="{{'generic.buttons.accessToPersonalArea' | translate}}"
                attr.aria-label="{{'generic.buttons.accessToPersonalArea' | translate}}">
                {{"generic.buttons.accessToPersonalArea" | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['/'+storeService.codIpa+'/services-without-registration']" tabindex="0"
                title="{{'generic.labels.withoutRegistration' | translate}}"
                attr.aria-label="{{'generic.labels.withoutRegistration' | translate}}">
                {{'generic.labels.withoutRegistration' | translate}}
              </a>
            </li>
            <li>
              <a href="#" tabindex="0" title="{{'generic.labels.basket' | translate}}"
                attr.aria-label="{{'generic.labels.basket' | translate}}"
                [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + (isPersonalRoute | fn:getRoute.bind(this))]">
                {{"generic.labels.basket" | translate}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col gb_agencyFoot">
        <ng-container *ngIf="this.authService.isLogged()">
          <ul>
            <li>
              <a [routerLink]="['/'+ this.storeService.codIpa, 'personal', 'privacy']" tabindex="0" title="{{'generic.buttons.privacy' | translate}}"
                attr.aria-label="{{'generic.buttons.privacy' | translate}}">
                {{"generic.buttons.privacy" | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['/'+ this.storeService.codIpa, 'personal', 'legal']" tabindex="0" title="{{'generic.buttons.legal' | translate}}"
                attr.aria-label="{{'generic.buttons.legal' | translate}}">
                {{"generic.buttons.legal" | translate}}
              </a>
            </li>
            <!-- <li>
              <a href="#" tabindex="0" title="{{'generic.buttons.credits' | translate}}"
                attr.aria-label="{{'generic.buttons.credits' | translate}}">
                {{"generic.buttons.credits" | translate}}
              </a>
            </li>
            <li>
              <a href="#" tabindex="0" title="{{'generic.buttons.faq' | translate}}"
                attr.aria-label="{{'generic.buttons.faq' | translate}}">
                {{"generic.buttons.faq" | translate}}
              </a>
            </li> -->
          </ul>
        </ng-container>
        <ng-container *ngIf="!this.authService.isLogged()">
          <ul>
            <li>
              <a [routerLink]="['/'+ this.storeService.codIpa, 'privacy']" tabindex="0" title="{{'generic.buttons.privacy' | translate}}"
                attr.aria-label="{{'generic.buttons.privacy' | translate}}">
                {{"generic.buttons.privacy" | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['/'+ this.storeService.codIpa, 'legal']" tabindex="0" title="{{'generic.buttons.legal' | translate}}"
                attr.aria-label="{{'generic.buttons.legal' | translate}}">
                {{"generic.buttons.legal" | translate}}
              </a>
            </li>
          </ul>
        </ng-container>
        <a href="http://www.greenbubble.it" target="_blank" rel="noopener">digital agency <strong>Greenbubble</strong></a>
      </div>
    </div>
  </div>
</footer>

<!-- popupAvvisoPagamento modal -->
<div class="modal fade" id="popupAvvisoPagamentoModal" tabindex="-1" aria-labelledby="popupAvvisoPagamentoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="popupAvvisoPagamentoModalLabel">{{ 'footer-modale-esempio-modello' | translate
          }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img src="./assets/gb/img/modello-avviso-di-pagamento.png" class="img-fluid" alt="codice esempio" />
      </div>
    </div>
  </div>
</div>

<!-- popupVerbaleDiAccertamento modal -->
<div class="modal fade" id="popupVerbaleDiAccertamento" tabindex="-1" aria-labelledby="popupVerbaleDiAccertamentoLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="popupVerbaleDiAccertamentoLabel">{{ 'footer-modale-esempio-modello' | translate
          }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img src="./assets/gb/img/verbale-di-accertamento.png" class="img-fluid" alt="codice esempio" />
      </div>
    </div>
  </div>
</div>

<!-- Esempio di modello: NON USATA - sostituita da popupAvvisoPagamento -->
<!-- <div class="gb-popup d-none" data-tipo="recupero_info" id="recuperInformazioni" aria-labelledby="hw-recuoerInfo"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h2_pp">{{ 'footer-modale-esempio-modello' | translate }}</span>
      <button type="button"
        title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0"
        class="gb-close-pp gb-button-reset" tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <img src="./assets/gb/img/codice-esempio.jpg" class="img-fluid" alt="codice esempio" />
    </div>
  </div>
</div> -->

<!-- Eliminare posizione -->
<div class="gb-popup s-allert d-none" data-tipo="clear_posizione" id="clearopition" aria-labelledby="pos-clear"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-eliminare-posizione' | translate }}</span>
    </div>
    <div class="gb-popup-foot">
      <button type="button" class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="deleteDebtPosition()">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Eliminare carrelli e pagamenti -->
<div class="gb-popup s-allert d-none" data-tipo="clear_all_carrelli" id="clear-all-carrelli"
  aria-labelledby="pos-clear-all-carrelli" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-eliminare-carrelli-e-pagamenti' | translate }}</span>
    </div>
    <div class="gb-popup-foot">
      <button type="button" class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '')">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Eliminare il carrello -->
<div class="gb-popup s-allert d-none" data-tipo="clear_carrello" id="clearcarrello" aria-labelledby="pos-clear-carrello"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-eliminare-carrello' | translate }}</span>
    </div>
    <div class="gb-popup-foot">
      <button *ngIf="router.url.includes('/personal')" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="this.cartService.svuotaCarrello(this.storeService.codIpa,this.cartService.cartTipoToDelete)">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button *ngIf="router.url.includes('/services-without-registration')" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="this.cartService.svuotaCarrelloAnonimo(this.cartService.cartTipoToDelete)">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Rimuovere il pagamento dal carrello -->
<div class="gb-popup s-allert d-none" data-tipo="clear_pagamento" id="clearpagamento"
  aria-labelledby="pos-clear-pagamento" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-rimuovere-pagamento' | translate }}</span>
    </div>
    <div class="gb-popup-foot">
      <button *ngIf="router.url.includes('/personal')" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="this.cartService.rimuoviDalCarrello(this.cartService.cartTipoToDelete, this.cartService.pagamentoToRemove)">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button *ngIf="router.url.includes('/services-without-registration')" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec"
        (click)="this.cartService.rimuoviDalCarrelloAnonimo(this.cartService.cartTipoToDelete, this.cartService.pagamentoToRemove)">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Eliminazione dati area personale -->
<div class="gb-popup d-none" data-tipo="clear_datipersonali" id="cleardati" aria-labelledby="cl-datipersonali"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h2_pp">{{ 'footer-modale-eliminazione-titolo' | translate }}</span>
      <button type="button" title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset"
        tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <p>{{ 'footer-modale-eliminazione-par-1' | translate }}</p>
      <p>{{ 'footer-modale-eliminazione-par-2' | translate }}</p>
      <p>{{ 'footer-modale-eliminazione-par-3' | translate }}</p>
      <p>{{ 'footer-modale-eliminazione-par-4' | translate }}</p>
    </div>
    <div class="gb-popup-foot">
      <button title="Avanti" type="button" class="gb-button-reset gb_btncta r grad small gb-close-pp-exec"
        (click)="deletePersonalData()">
        <span>{{ 'footer-modale-eliminazione-conferma' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Redirect alla Homepage -->
<div class="gb-popup s-allert d-none" data-tipo="alert_multiutente" id="hommulti" aria-labelledby="alert-multiutente"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-redirect-titolo' | translate }}</span>
    </div>
    <div class="gb-popup-main" status="clear warning">
      <span class="gb_sm_p_pp text-center"
        [innerHtml]="'footer-modale-redirect-homepage-message' | translate | safeHtml"></span>
    </div>
    <div class="gb-popup-foot">
      <button [routerLink]="['/']" (click)="logoutAndGoToHome()" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Redirect all'area personale -->
<div class="gb-popup s-allert d-none" data-tipo="block-login" aria-labelledby="alert-block-login" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-redirect-titolo' | translate }}</span>
    </div>
    <div class="gb-popup-main" status="clear warning">
      <span class="gb_sm_p_pp text-center">{{ 'footer-modale-redirect-area-personale-message-1' | translate }}</span>
      <span class="gb_sm_p_pp text-center"
        [innerHtml]="'footer-modale-redirect-area-personale-message-2' | translate | safeHtml"></span>
    </div>
    <div class="gb-popup-foot">
      <button (click)="loginAndNavigate()" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Redirect ai servizi senza registrazione -->
<div class="gb-popup s-allert d-none" data-tipo="alert_logout" id="logout" aria-labelledby="alert-logout"
  aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h4_pp">{{ 'footer-modale-redirect-titolo' | translate }}</span>
    </div>
    <div class="gb-popup-main" status="clear warning">
      <span class="gb_sm_p_pp text-center"
        [innerHtml]="'footer-modale-redirect-servizi-senza-registrazione-message' | translate | safeHtml"></span>
    </div>
    <div class="gb-popup-foot">
      <button [routerLink]="['/']" (click)="logoutAndGoServiceWithoutRegistration()" type="button"
        class="gb-button-reset me-2 gb_btncta g x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-si' | translate }}</span>
      </button>
      <button type="button" class="gb-button-reset gb_btncta r x_small grad gb-close-pp-exec">
        <span>{{ 'footer-modale-redirect-no' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Ricerca Predeterminato: inserimento email per ANONIMO modal -->
<div class="modal fade" id="inserimentoEmailAnonimoModal" tabindex="-1"
  aria-labelledby="inserimentoEmailAnonimoModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="inserimentoEmailAnonimoModalLabel">{{ 'completa-profilo-email' | translate }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{ 'completa-profilo-titolo-footer' | translate }}
        <hr />
        <form [formGroup]="anonimousEmailForm">
          <div class="row m-0">
            <!-- Commentato *ngIf="shouldShowCodiceFiscaleField" perchè con ANONIMO bloccava il flusso -->
            <div class="col-12" *ngIf="shouldShowCodiceFiscaleField">
              <div class="mb-3">
                <label class="form-label">{{ 'ricerca-posizioni-cf-debitore' | translate }}</label>
                <input type="text" placeholder="AAABBB99C99D99F" class="form-control" id="codiceFiscale" name="codiceFiscale"
                  formControlName="codiceFiscale" autocomplete="off">
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label class="form-label">{{ 'completa-profilo-email' | translate }}</label>
                <input type="email" class="form-control" id="emailAddress" name="emailAddress"
                  formControlName="emailAddress" autocomplete="off">
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label class="form-label">{{ 'completa-profilo-ripeti-email' | translate }}</label>
                <input type="email" class="form-control" id="confirmEmailAddress" name="confirmEmailAddress"
                  formControlName="confirmEmailAddress" autocomplete="off">
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3 text-end">
                <button type="submit"
                  [disabled]="anonimousEmailForm.invalid"
                  class="btn btn-sm bg-primary text-white"
                  (click)="onAddEmail()">{{ 'completa-profilo-aggiungi' | translate }}</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- [x]: PAF - Attivazione features -->
<div class="gb-popup d-none" data-tipo="user-features" aria-labelledby="alert-user-features" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h2_pp">{{ 'paf-title' | translate }}</span>
      <button type="button" title="{{ 'paf-close' | translate }}"
        attr.aria-label="{{ 'paf-close' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset"
        tabindex="0" (click)="closeExtendedFunctionalitiesPopup()">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'paf-close' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <!-- Solo 1 delle funzionalità non è attiva -->
      <section *ngIf="userService.userPagamentoVeloceFunctionality || userService.userAreaEstesaFunctionality">
        <em>{{ 'paf-description-1' | translate }}</em>
      </section>
      <!-- Entrambe le funzionalità non sono attive -->
      <section *ngIf="!userService.userPagamentoVeloceFunctionality && !userService.userAreaEstesaFunctionality">
        <em>{{ 'paf-description-2' | translate }}</em>
        <div class="text-center mt-2">
          <button type="button" class="gb-button-reset gb_btncta g grad small" (click)="userFunctionalityBothActivation()">
            <span>{{ 'paf-both-activation' | translate }}</span>
          </button>
        </div>
      </section>
      <hr />
      <section *ngIf="!userService.userPagamentoVeloceFunctionality">
        <h6><b>{{ 'paf-pagamento-veloce-title' | translate }}</b></h6>
        <p [innerHTML]="'paf-pagamento-veloce-description' | translate"></p>
        <div class="text-end">
          <!-- [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + '/personal/mydata']" -->
          <button type="button" class="gb-button-reset gb_btncta g grad small" (click)="userFunctionalityActivation('pagamentoVeloce')">
            <span>{{ 'paf-pagamento-veloce-button' | translate }}</span>
          </button>
        </div>
        <hr />
      </section>
      <section *ngIf="!userService.userAreaEstesaFunctionality">
        <h6><b>{{ 'paf-area-estesa-title' | translate }}</b></h6>
        <p [innerHTML]="'paf-area-estesa-description' | translate"></p>
        <div class="text-end">
          <!-- [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + '/personal/extension-area']" -->
          <button type="button" class="gb-button-reset gb_btncta g grad small" (click)="userFunctionalityActivation('areaEstesa')">
            <span>{{ 'paf-area-estesa-button' | translate }}</span>
          </button>
        </div>
        <hr />
      </section>
    </div>
  </div>
</div>

<!-- On Top -->
<button type="button" title="{{ 'footer-on-top' | translate }}" aria-hidden="true" tabindex="-1"
  attr.aria-label="{{ 'footer-on-top' | translate }}" class="gb-button-reset" id="gb_scrolltop">
  <span>
    <svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z">
      </path>
    </svg>
    <em class="gb-hidden-visually gb-speak">{{ 'footer-on-top' | translate }}</em>
  </span>
</button>
